import React from 'react';
import PropTypes from 'prop-types';
import './styles.css';

const POSITION_CLASSES = {
  bottomleft: 'leaflet-bottom leaflet-left',
  bottomright: 'leaflet-bottom leaflet-right',
  topleft: 'leaflet-top leaflet-left',
  topright: 'leaflet-top leaflet-right',
};

// Dead-simple overlay: just use Leaflet's position classes
const OverlayControl = ({ position, className, children }) => {
  const posClass = POSITION_CLASSES[position] || POSITION_CLASSES.topleft;
  return (
    <div className={posClass}>
      <div className={`leaflet-control custom-map-overlay${className ? ' ' + className : ''}`}>
        {children}
      </div>
    </div>
  );
};

OverlayControl.propTypes = {
  position: PropTypes.oneOf(['topleft', 'topright', 'bottomleft', 'bottomright']),
  className: PropTypes.string,
  children: PropTypes.node,
};

OverlayControl.defaultProps = {
  position: 'topleft',
  className: '',
  children: null,
};

export default OverlayControl;
